export default {
  add: "اشیاء شامل کریں",
  sale: "فروخت اشیاء",
  items: "تمام اشیاء",
  summary: "خلاصہ",
  notifications: "اطلاعات",
  registerinfo:
    "یہ آپ کا نیا صارف نام اور آئ-ڈی ہے۔ براہ کرم اس آئ-ڈی کو یاد رکھیں کیونکہ یہ ویب سائٹ میں لاگ ان کرنے کے لئے استعمال ہوگا۔",
  companyProfiles: "کمپنی پروفائلز",
  bills: "بلز",
  salereturnbills: "سیل ریٹرن بل",
  ledger: "لیجرز",
  sale_return: "فروخت کی واپسی",
  purchase: "خریداری کے آرڈر",
  finalizedOrders: "حتمی آرڈر",
  saleLedgers: "سیل لیجرز",
  purchaseLedgers: "خریدار لیجرز",
  dashboard: "ڈیش بورڈ",
  orders: " آرڈرز",
  quotation: "کوٹیشن",
  daily_book: "ڈیلی بک",
  warehouse: "گودام",
  vouchers: "واؤچر",
  voucheritems: "واؤچر آئٹمز",
  rack: "ریک",
  reports: "رپورٹیں",
  bank: "بینک",
  bill_template: "بل ٹیمپلیٹ",
  invoice: "رسید",
};
